module.exports = __webpack_public_path__ + "as.d6923bae5280bf7a154a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/as.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/as.svg
// module chunks = styles